import React from 'react';
import PropTypes from 'prop-types';

const CrossBorder = ({ theme, fill }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.1667 11.9V16.7417C19.1689 17.0622 19.1072 17.3799 18.9851 17.6762C18.8629 17.9725 18.6829 18.2415 18.4555 18.4674C18.2281 18.6932 17.9579 18.8714 17.6608 18.9915C17.3636 19.1116 17.0455 19.1711 16.725 19.1667H16.0917C16.675 19.1667 16.725 17.5 16.7167 16.7584V14.3084C16.7166 13.9885 16.7803 13.6719 16.9039 13.377C17.0275 13.0821 17.2087 12.8147 17.4367 12.5905C17.6648 12.3663 17.9352 12.1898 18.2322 12.0712C18.5293 11.9527 18.8469 11.8945 19.1667 11.9V11.9Z"
      fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
    />
    <path
      d="M8.05 0.833374C8.0522 1.15104 7.99153 1.466 7.87148 1.76012C7.75144 2.05424 7.57439 2.3217 7.35053 2.54711C7.12668 2.77251 6.86044 2.9514 6.56716 3.07347C6.27388 3.19554 5.95934 3.25838 5.64167 3.25837H3.23333V3.63337C3.23333 3.63337 3.1 0.833374 3.85 0.833374H8.05Z"
      fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
    />
    <path
      d="M16.0917 19.1667H0.833333V3.25837C0.831137 2.94141 0.891534 2.62713 1.01106 2.33355C1.13059 2.03998 1.30689 1.77288 1.52986 1.54759C1.75283 1.3223 2.01808 1.14324 2.3104 1.02067C2.60272 0.898114 2.91636 0.834463 3.23333 0.833374H3.85C3.1 0.833374 3.23333 3.61671 3.23333 3.61671V16.7417H16.7167C16.725 17.5 16.6667 19.1667 16.0917 19.1667Z"
      fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
    />
    <path
      d="M12.8167 13.4666C11.5708 13.4584 10.3553 13.0814 9.32337 12.3833C8.29146 11.6851 7.4894 10.6971 7.01832 9.54366C6.54724 8.39026 6.42824 7.1232 6.67633 5.90226C6.92443 4.68132 7.5285 3.56118 8.41237 2.68311C9.29625 1.80504 10.4203 1.20835 11.6429 0.968301C12.8654 0.72825 14.1317 0.855586 15.282 1.33425C16.4322 1.81291 17.415 2.62147 18.1063 3.65794C18.7977 4.69442 19.1666 5.91241 19.1667 7.1583C19.1656 7.98992 19.0003 8.81315 18.6803 9.58074C18.3603 10.3483 17.8918 11.0452 17.3018 11.6313C16.7119 12.2174 16.0119 12.6812 15.2423 12.9962C14.4726 13.3111 13.6483 13.471 12.8167 13.4666V13.4666ZM12.8167 2.9333C11.9814 2.93494 11.1654 3.18414 10.4717 3.64938C9.77795 4.11463 9.23772 4.77506 8.91922 5.54722C8.60072 6.31939 8.51824 7.16863 8.6822 7.98765C8.84616 8.80667 9.24921 9.55871 9.84042 10.1488C10.4316 10.7388 11.1845 11.1404 12.0038 11.3027C12.8231 11.4651 13.6722 11.3809 14.4438 11.0609C15.2153 10.7409 15.8747 10.1993 16.3385 9.50471C16.8024 8.8101 17.05 7.99357 17.05 7.1583C17.0478 6.03699 16.6008 4.96237 15.8071 4.17026C15.0135 3.37816 13.938 2.93329 12.8167 2.9333V2.9333Z"
      fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
    />
    <path
      d="M17.7417 3.21671C17.7417 3.21671 14.2583 0.933394 10.25 3.75006C10.25 3.75006 10.7667 1.11671 13.9 0.958374C15.4159 1.20979 16.7847 2.01445 17.7417 3.21671Z"
      fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
    />
    <path
      d="M6.51667 6.93333C6.57003 7.13011 6.64551 7.32021 6.74167 7.5C7.02259 8.02049 7.45595 8.44264 7.98362 8.70983C8.51129 8.97702 9.10804 9.07647 9.69384 8.99486C10.2796 8.91325 10.8265 8.65447 11.261 8.25322C11.6956 7.85197 11.997 7.32745 12.125 6.75L14.1667 7.19167C13.9338 8.20403 13.3914 9.11873 12.6148 9.80869C11.8383 10.4986 10.8661 10.9296 9.83333 11.0417C9.22116 11.1125 8.60271 10.9794 8.07387 10.663C7.54503 10.3466 7.13535 9.86459 6.90833 9.29167C6.61472 8.54148 6.4813 7.73816 6.51667 6.93333V6.93333Z"
      fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
    />
    <path
      d="M10.8917 6.97497L10.6917 5.77497L13.7667 5.24164C14.034 5.19566 14.3087 5.25756 14.5305 5.41377C14.7524 5.56997 14.9032 5.80774 14.95 6.07497L15.4833 9.16664L14.2833 9.37497C14.0657 9.40857 13.8437 9.35469 13.6657 9.22509C13.4877 9.09549 13.3682 8.90071 13.3333 8.6833L13.125 7.44164L11.8833 7.6583C11.7755 7.6775 11.665 7.67527 11.5581 7.65173C11.4511 7.62819 11.3499 7.58381 11.2601 7.52113C11.1703 7.45844 11.0938 7.37868 11.0349 7.28639C10.9759 7.19411 10.9358 7.09112 10.9167 6.9833L10.8917 6.97497Z"
      fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
    />
    <defs>
      <linearGradient
        id="paint0_linear_7287_12073"
        x1="18.6083"
        y1="12.0748"
        x2="15.3686"
        y2="29.4216"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F5B900" />
        <stop offset="1" stopColor="#F9781C" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_7287_12073"
        x1="7.90258"
        y1="2.23397"
        x2="2.36903"
        y2="2.23397"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F5B900" />
        <stop offset="1" stopColor="#F9781C" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_7287_12073"
        x1="1.12713"
        y1="9.99809"
        x2="17.601"
        y2="9.99809"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F5B900" />
        <stop offset="1" stopColor="#F9781C" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_7287_12073"
        x1="32.6778"
        y1="11.4034"
        x2="0.90794"
        y2="0.72218"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E9B1" />
        <stop offset="1" stopColor="#8457E5" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_7287_12073"
        x1="15.8727"
        y1="2.55337"
        x2="11.348"
        y2="2.07928"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#17D0BA" />
        <stop offset="0.99" stopColor="#716CDE" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_7287_12073"
        x1="7.25"
        y1="11.25"
        x2="13.7185"
        y2="5.38772"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E9B1" />
        <stop offset="1" stopColor="#8457E5" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_7287_12073"
        x1="15.8327"
        y1="5.66836"
        x2="10.4841"
        y2="2.59875"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E9B1" />
        <stop offset="1" stopColor="#8457E5" />
      </linearGradient>
    </defs>
  </svg>
);

CrossBorder.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default CrossBorder;
